module.exports = __webpack_public_path__ + "img/pm.df1be377.svg";